var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyGiftIcon = function SvgHappyGiftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGiftIcon_svg__a)",
    d: "M2.125 15.25a2.5 2.5 0 0 0 2.5 2.5H8.22a.156.156 0 0 0 .156-.156v-7.188a.156.156 0 0 0-.156-.156H2.438a.313.313 0 0 0-.313.313zm6.25-6.406V4.625h1.25v4.219A.156.156 0 0 0 9.781 9h5.47a1.87 1.87 0 0 0 1.53-.793c.223-.317.344-.694.344-1.082V6.5a1.875 1.875 0 0 0-1.875-1.875h-1.583a.078.078 0 0 1-.067-.117A2.812 2.812 0 0 0 9 1.298a2.812 2.812 0 0 0-4.6 3.21.078.078 0 0 1-.066.117H2.75A1.875 1.875 0 0 0 .875 6.5v.625A1.88 1.88 0 0 0 2.75 9H8.22a.156.156 0 0 0 .156-.156m1.25-5.782a1.562 1.562 0 1 1 1.563 1.563H9.625zM6.701 1.504a1.563 1.563 0 0 1 1.674 1.558v1.563H6.813a1.562 1.562 0 0 1-.112-3.12zm3.08 16.246h3.594a2.5 2.5 0 0 0 2.5-2.5v-4.687a.313.313 0 0 0-.312-.313H9.78a.156.156 0 0 0-.156.156v7.188a.156.156 0 0 0 .156.156"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGiftIcon_svg__a",
    x1: 17.125,
    x2: -0.316,
    y1: 17.75,
    y2: 1.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })))));
};
export default SvgHappyGiftIcon;